import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  focusable: "false",
  "aria-hidden": "true"
};
const _hoisted_2 = ["xlink:href", "href"];
export default {
  __name: 'SvgIcon',
  props: {
    svgSymbolId: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("use", {
        "xlink:href": `#${__props.svgSymbolId}`,
        href: `#${__props.svgSymbolId}`
      }, null, 8, _hoisted_2)]);
    };
  }
};